$(function() {

  function getBasketCount(fallbackCount) {
    const basketCountCookie = document.cookie.split('; ').find(
        (row) => row.startsWith('cs_basket_count=')
    )
    if (basketCountCookie === undefined) { return fallbackCount }
    return parseInt(basketCountCookie.split('=')[1])
  }

  function showNotifier(message) {
    $.notify({
        message: message
    }, {
        type: 'info',
        placement: {
            from: 'bottom',
            align: 'right'
        }
    });
  }

  if (typeof BACKEND_MESSAGES != 'undefined' && BACKEND_MESSAGES.length) {
      [].forEach.call(BACKEND_MESSAGES, showNotifier);
  }

  if (typeof SHOW_LOGIN_POPUP != 'undefined' && SHOW_LOGIN_POPUP) {
    $('#js-user-login-modal').modal({'keyboard': false, 'backdrop': 'static'});
  }

  if (typeof URL_ENDPOINT != 'undefined' && URL_ENDPOINT == 'tree.search') {
    if (typeof (NO_AUTO_SCROLL) == 'undefined') {
      (function($, document, window, viewport) {
        $(document).ready(function() {
          if (viewport.is('xs')) {
            $('html, body').scrollTop($('#js-mobile-nav').offset().top);
          }
        });
      })(jQuery, document, window, ResponsiveBootstrapToolkit);
    }
  }

  // STICKY HEADER
  if ($('.navbar-sticky').length || $('.js-navbar-sticky').length){
    var scrollHeight = (typeof(SCROLL_START)!='undefined') ? SCROLL_START : 47;
    var $body = $('body');
    $(window).scroll(function() {
      var pageTop=$(this).scrollTop();
      if (pageTop>scrollHeight) {
        $body.addClass('scrolling');
      } else {
        $body.removeClass('scrolling');
      }
    });
  }

  // MOBILE SEARCH
  var mobile_top_menu = $('.js-mobile-top-menu'),
      mob_search = $('#js-mobile-search-bar');

  //needs to be removed after the class transition is done for all customer theme's
  if (mobile_top_menu == undefined || mobile_top_menu.length == 0) {
    mobile_top_menu = $('.mobile-top-menu');
  }

  mobile_top_menu.on('click','#js-search-toggle',function(e){
    e.preventDefault();
    mob_search.toggleClass('open');
  });

  // HAMBURGER MENU
  if (typeof(NO_OFF_CANVAS) == 'undefined') {
    var row_offcanvas = $('.js-row-offcanvas');
    //needs to be removed after the class transition is done for all customer theme's
    if(row_offcanvas == undefined || row_offcanvas.length == 0) {
      row_offcanvas = $('.row-offcanvas');
    }
    mobile_top_menu.on('click','#js-sidebar-toggle',function(e){
      e.preventDefault();
      row_offcanvas.toggleClass('active');
    });

    // .overlay needs to be removed after the class transition is done for all customer theme's
    $('.js-overlay, .overlay').on('click',function(){
      row_offcanvas.toggleClass('active');
    });

    if (typeof(NO_HAMMER_SWIPE) == 'undefined') {
      $(document).ready(function() {
        delete Hammer.defaults.cssProps.userSelect;
        var bodyElement = document.getElementsByTagName('body')[0];
        var mc = new Hammer(bodyElement);
        mc.on('swipeleft swiperight', function(ev) {
          row_offcanvas.toggleClass('active');
        });
      });
    }
  }

  // NAVIGATION SUBMENU
	var navbar_nav = $('.js-navbar').find('.js-nav'),
		  menu_items = $('.js-navbar').find('.js-nav-item');

  if(navbar_nav == undefined || navbar_nav.length == 0) {
    navbar_nav = $('#navbar .nav');
  }
  if(menu_items == undefined || menu_items.length == 0) {
    menu_items = $('#navbar .nav>li');
  }
	menu_items.hoverIntent(
		function() {
			var $li = $(this);
			$li.siblings().each(function() {
				$(this).find('a').removeClass('active');
			});
			$li.find('a').addClass('active');

			// Fix submenu going off-screen
			var $submenu = $li.find('.js-submenu');
			//remove below if statement after all themes are transisioned to new css/js class split
      if ($submenu == undefined || $submenu.length == 0) {
        $submenu = $li.find('.submenu');
      }

      var li_left = $li.offset().left,
          sub_width = $submenu.outerWidth(),
          doc_width = window.innerWidth || document.body.clientWidth;

			if (li_left + sub_width > doc_width - 20) {
				$submenu.addClass('fitX');
			} else {
				$submenu.removeClass('fitX');
			}
		},
		function() {}
	);

	navbar_nav.on('mouseleave', function() {
		clearTimeout(navbar_nav.data('timeout'));
		navbar_nav.data('timeout', setTimeout(function() {
			menu_items.find('a').removeClass('active');
		}, 500));
	});

	navbar_nav.on('mouseenter', function() {
		clearTimeout(navbar_nav.data('timeout'));
	});

  // BASKET PREVIEW
  if (typeof(BASKET_PREVIEW) != 'undefined') {
    var basket = $('.js-header').find('.js-basket');
    //remove below if statements after all themes are transisioned to new css/js class split
    if (basket == undefined || basket.length == 0) {
      basket = $('.header .basket');
    }

    var basket_link = basket.find('.js-link')
    if (basket_link == undefined || basket_link.length == 0) {
      basket_link = basket.find('.link');
    }

    var preview = basket.children('.js-basket-preview');
    if (preview == undefined || preview.length == 0) {
      preview = basket.children('.basket-preview');
    }

    if (preview.length){
      var closePreview = function(){
        basket.data('timeout',setTimeout(function(){
          basket.removeClass('preview');
        },500));
      };

			basket_link.hoverIntent({
				sensitivity: 2,
				interval: 50,
				timeout: 10,
				over: function(){
					clearTimeout(basket.data('timeout'));
					var url = preview.attr('data-url');
					if (url) {
						$.ajax({ type:'get', url:url, cache:false,
							success: function(data){
								preview.html(data);
							}
						});
						basket.addClass('preview');
					}
				},
				out: closePreview
			});
			preview.hoverIntent({
				sensitivity: 2,
				interval: 50,
				timeout: 10,
				over: function(){ clearTimeout(basket.data('timeout')); },
				out: function(){ closePreview(); }
			});
		}
	}

  $('.js-confirm-order-button, #confirm_order_button').on('click', async function(){
    let form = $('.js-confirm-form');
    if (form === undefined || form.length === 0) {
      form = $('#confirm-form');
    }
    $(this).prop('disabled', true).addClass('disabled');
    $('#js-loader-modal').modal({ backdrop: 'static', keyboard: false });

    try {
      const clientId = ga.getAll()[0].get('clientId');
      form.find('input[name=ga_client_id]').val(clientId);

      const gaTargetID = form.attr('data-ga-target-id');
      if (gaTargetID) {
        const sessionId = await getGoogleSessionID(gaTargetID);
        form.find('input[name=ga_session_id]').val(sessionId);
      }
    }
    catch(error) {
      console.error(error)
    }
    finally {
      form.submit();
    }
  });

  // ORDER FORM
  if (typeof(QUANTITY_SPINNER) !== 'undefined') {
    var initNumericStepper = function(){
      var form = $('.js-order-form');
      //remove below if statement after all themes are transisioned to new css/js class split
      if (form == undefined || form.length == 0) {
        form = $('.order-form');
      }
      form.find('input[type=number]').each(function(){
        var spinner = $(this);
        spinner.TouchSpin({
          min:parseInt(spinner.attr('min')),
          max:10000,
          step:parseInt(spinner.attr('step')),
          value:parseInt(spinner.val())
        }).on('keydown',function(e){
          if (e.which===13) { // enter key
            $(this).trigger("touchspin.uponce").trigger("touchspin.downonce"); // refresh hack
          }
        });
      });
    }
    initNumericStepper();
  }

  $(document).on('change', '#product-options input, .js-product-options input', function() {
    // only for product detail page
    var input = $('.js-product-details-wrapper').find('.js-order-form').find('input');
    //remove below if statement after all themes are transisioned to new css/js class split
    if (input == undefined || input.length == 0) {
      input = $('.product-details-wrapper .order-form input');
    }

    var submit = input.parent().find('button[type=submit]');

    submit.prop('disabled', false);
  });

  $(document).on('change blur', '.order-form input, .js-order-form input', function() {
    var input = $(this);
    if (input.hasClass('product-added')) {
      var quantity = input.attr('data-quantity'),
          submit = input.closest('.js-order-form').find('button[type=submit]');
      //remove below if statement after all themes are transisioned to new css/js class split
      if (submit == undefined || submit.length == 0) {
        submit = input.closest('.order-form').find('button[type=submit]');
      }

      if (input.val() !== quantity) {
        submit.prop('disabled', false);
      } else {
        submit.prop('disabled', true);
      }

      if (
        input.val() !== quantity &&
        submit.attr('data-offline-disabling') &&
        submit.attr('data-offline-disabling') === 'disabled'
      ) {
        submit.prop('disabled', false);
        submit.attr('data-offline-disabling-temporary', true);
      } else if (
        submit.attr('data-offline-disabling') &&
        submit.attr('data-offline-disabling') === 'disabled'
      ) {
        submit.prop('disabled', true);
        submit.removeAttr('data-offline-disabling-temporary');
      }
    }
  });

  var handleOrderFormClick = throttle(500, true, function(submit_btn) {
    var form = submit_btn.parents('form'),
        url = form.prop('action'),
        view_func = form.data('view-func'),
        product = form.find('input[name=product]').val(),
        contract_id = form.find('input[name=contract_id]').val(),
        thum = form.find('input[name=thum]').val(),
        con = form.find('input[name=con]').val(),
        quantity_input = form.find('input[name=quantity]'),
        quantity = quantity_input.val(),
        memo = $('input[name=memo]').val(),
        error = form.find('.js-error-message'),
        template_input = form.find('input[name=template_state]'),
        template_state = template_input.length ? template_input.val() : 0;

    // loader icon
    if (submit_btn.hasClass('js-order-loader')) {
      submit_btn.addClass('loader-visible');
    }

    // product options
    var options = [];

    $('.product-option').each(function(index, item) {
      var checkbox = $(item).find('.js-option-input');
      var quantity = $(item).find('.js-option-quantity');
      if ($(checkbox).is(':checked')) {
        options.push({
          id: $(checkbox).attr('data-id'),
          quantity: $(quantity).val()
        });
      }
    });

    options = JSON.stringify(options);

    function getConfiguratorFormData($form){
      var unindexed_array = $form.serializeArray();
      var indexed_array = {};
      $.map(unindexed_array, function(n, i){
        if (n['name'].substring(0,4)=='text'){
          if (n['value']!=''){
            if(!indexed_array['text']) indexed_array['text'] = [];
            indexed_array['text'].push(n['value']);
          }
        } else {
          indexed_array[n['name']] = n['value'];
        }
      });
      return indexed_array;
    }

    // print configuration
    var configuration_form = $('.js-configurator-form');
    //remove below if statement after all themes are transisioned to new css/js class split
    if (configuration_form == undefined || configuration_form.length == 0) {
      configuration_form = $('#configurator-form');
    }

    var configuration = configuration_form.length ? getConfiguratorFormData(configuration_form) : {};
    configuration = JSON.stringify(configuration);

    // product configuration
    var configurator_payload = $('.js-configurator-payload');
    //remove below if statement after all themes are transisioned to new css/js class split
    if (configurator_payload == undefined || configurator_payload.length == 0) {
      configurator_payload = $('#configurator-payload');
    }

    var product_configuration = configurator_payload.data('value');

    // Loader modal configurator
    if ( configurator_payload.length ) {
      $('#js-loader-modal').modal({backdrop:'static',keyboard:false});
    }

    // upload configuration
    var upload_configuration = ""
    if ($('#image-upload-configuration').length) {
      upload_configuration = form.find('input[name=image_upload_configuration]').val()
    }

    $.post(url, {
      product:product,
      quantity:quantity,
      options:options,
      configuration:configuration,
      contract_id:contract_id,
      product_configuration: product_configuration,
      memo: memo,
      upload_configuration: upload_configuration,
      template_state: template_state,
      thum: thum,
      con: con
    }, function(data) {
        // redirect to basket
        if (data.action) {
          window.location.href = data.action;
        }

        if (submit_btn.hasClass('js-order-loader')) {
          submit_btn.removeClass('loader-visible');
        }

        $('#js-loader-modal').modal('hide');

        // everything good
        if (data.result && data.result.status) {
          if (view_func == 'basket.index') {
            window.location.reload();
          }

          form.replaceWith(data.result.html);
          $('.js-basket-small').replaceWith(data.result.b1);
          $('.js-basket-large').replaceWith(data.result.b2);

          // PREVIEW AFTER BASKET ADD
          if (typeof(BASKET_PREVIEW_ADD) !== 'undefined') {
            var bp = $('.js-basket-preview');
            //remove below if statement after all themes are transisioned to new css/js class split
            if (bp == undefined || bp.length == 0) {
              bp = $('.basket-preview');
            }

            var url = bp.attr('data-url');
            if (url) {
              $.ajax({ type:'get', url:url, cache:false,
                success: function(data){
                  bp.html(data);
                }
              });
              $('.header .basket, .js-header .js-basket').addClass('preview');
              bp.show();
              $('body').click(function(evt) {
                if ($(evt.target).hasClass('basket-preview')) {
                  return;
                }
                // for descendants
                if ($(evt.target).closest('.basket-preview').length || $(evt.target).closest('.js-basket-preview').length) {
                  return;
                }
                $('.header .basket, .js-header .js-basket').removeClass('preview');
              });
            }
          }

          if (typeof(QUANTITY_SPINNER) !== 'undefined') {
            initNumericStepper();
          }
          // open modal (premium selection for now)
          if (data.result.open_modal) {
            $('#js-premium-modal').data('url', data.result.open_modal);
            $('#js-premium-modal').modal('show');
          }
          // display modal
          else if (data.result.modal) {
            $('#js-order-modal').remove();
            $('body').append(data.result.modal);
            $('#js-order-modal').modal({'show': true});
          }
        }

        // problem
        if (data.result && !data.result.status) {
          error.removeClass('hidden');
          error.find('.alert').html(data.result.message);
          quantity_input.val(data.result.quantity);
        }
    }).fail(function(error){
        const optionsFlashMessage = {type: 'info', placement: { from: 'bottom', align: 'right'}};
        const errorMessage = JSON.parse(error.responseText).message
        if (error.status === 400 && errorMessage){
          $.notify({message: errorMessage}, optionsFlashMessage)
        }
    });

    return false;
  });

  $(document).on('click', '.order-form button[type=submit], .js-order-form button[type=submit]', function(e) {
    e.preventDefault();
    var submit_btn = $(this);
    handleOrderFormClick(submit_btn);
  });


	// PRODUCT OPTIONS
	if (typeof(NO_PRODUCT_OPTIONS_HOVER) == 'undefined') {

		$(document).ready(function() {
			(function($, document, window, viewport) {
				if (! viewport.is('xs')) {
					$('.product, .js-product').hoverIntent(function() {
						var options = $(this).find('.js-options-alt');
            //remove below if statement after all themes are transisioned to new css/js class split
            if (options == undefined || options.length == 0) {
                options = $(this).find('.options-alt');
            }

						options.toggleClass('hidden');
						options.find('ul').eq(0).removeClass('hidden');
						options.find('ul').eq(1).addClass('hidden');
						options.find('ul').eq(2).addClass('hidden');
						options.css('margin-top', -(options.height() - 5) + 'px');
					});
				}
			})(jQuery, document, window, ResponsiveBootstrapToolkit);
		});

	}

	// EQUAL HEIGHT COLUMNS
	$('.eq-element, .js-eq-element').responsiveEqualHeightGrid();

	// TOUCH EVENTS FOR BOOTSTRAP CAROUSEL
	var carousel = document.getElementById('js-carousel');
	if (carousel) {
		var mc = new Hammer(carousel);
		mc.on('swipeleft', function(ev) {
			ev.srcEvent.stopPropagation();
			$('#js-carousel').carousel('next');
		});
		mc.on('swiperight', function(ev) {
			ev.srcEvent.stopPropagation();
			$('#js-carousel').carousel('prev');
		});
  }

  // SLICK SLIDER
  $('.js-image-slider').slick({
    arrows: false,
    infinite: false,
    lazyLoad: 'ondemand'
  });
  $('.js-image-slider').slickLightbox({
    src: 'data-lightbox',
    itemSelector: '.item img',
    slick: {
      arrows: false,
      asNavFor: '.js-image-slider',
      infinite: false
    }
  });
  $('.js-slider-indicators').slick({
    arrows: false,
    infinite: false,
    slidesToShow: 6,
    swipeToSlide: true
  });
  $('.js-slider-indicators li[data-slide]').click(function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.js-image-slider').slick('slickGoTo', slideno);
	});


	// WORD!
	var lines = ["THE COMPLETE COMMERCE-PLATFORM", "THE FOUNDATION BEYOND YOUR ECOMMERCE STRATEGY", "THE BASE OF YOUR COMMERCIAL SUCCESS", "STABLE WEBSHOPS AND ADVANCED MANAGEMENT", "YOUR PARTNER IN SMART ONLINE BUSINESS"]
	console && console.log("%cCLOUDSUITE\n%c" + lines[Math.floor(Math.random()*lines.length)],
		"font-size:1.5em;color:#0C172D;", "color:#37AE83;font-size:1em;");


	// NOT SURE WHAT THIS DOES (SOME MOBILE NAV STUFF)
	$('.js-collapse-down').click(function(e) {
		e.preventDefault();
		var $next = $(this).next();
		if ($next.is(":visible")) {
			$next.hide();
		} else {
			$next.show();
		}
	});


	// MODAL FULL WINDOW SIZE
	$('.bs-example-modal-lg').on('show.bs.modal', function () {
		$('.modal-content').css('height', $(window).height() - 20);
		$('.modal-body').css('height', $(window).height() - 150);
		$('.modal-body').css('overflow-y', 'scroll');
	});


	// SORT MODES
	$(document).on('change', '#js-sort-modes', function() {
		window.location.href = this.value;
	});

  // RESULTS PER PAGE
  var num_results_obj = $('#js-num-results');
  if (num_results_obj.length){
    var res_number;

    if(Cookies.get('cs_maxresult')!==undefined){
      num_results_obj.find('option[value="default"]').addClass('hidden');
    }
    num_results_obj.on('change',function() {
      res_number = this.options[this.selectedIndex].value;
      Cookies.set('cs_maxresult',res_number,{expires:7,path:'/'});

      var current_page = new URL(window.location.href)
      current_page.searchParams.set('page', '1')
      current_page.search = current_page.searchParams.toString()

      window.location.href = current_page.toString()
    });
  }


	// SELECTA
	$('.selecta').selectpicker({
      noneSelectedText: js_translations['selectpickerNoneSelected'],
      noneResultsText: js_translations['selectpickerNoneResults'] + ' {0}',
      container: 'body'
    });


	// TOOLTIPS
	$('[data-toggle="tooltip"]').tooltip();


	// TOTOP
	(function($, document, window, viewport) {
		if (! viewport.is('xs')) {
			if (($(window).height() + 100) < $(document).height() ) {
				$('#top-link-block, .js-top-link-block').removeClass('hidden').affix({
					offset: {top:100}
				});
			}
		}
	})(jQuery, document, window, ResponsiveBootstrapToolkit);
	$('#top-link-block a, .js-top-link-block a').click(function() {
		$('html, body').animate({scrollTop: 0}, 'slow');
	});


	// LOGIN MODAL
	$('#js-login-modal').on('shown.bs.modal', function(e) {
		$('#input-login-email, .js-input-login-email').focus();
		// redirect to data-ref if specified
		var url = $(e.relatedTarget).data('ref');
		if (url) {
			$('#js-login-modal').find('input[name=return_url]').val(url)
		}
  });


	// NEW REGISTRATION ANOTHER USER MODAL
  $('#js-registration-user-modal').on('show.bs.modal', function(e) {
    var url = $(e.relatedTarget).data('url');
    modalFillContent($(this), url);
  }).on('click','.btn-submit-form, .js-btn-submit-form', function(e){
    window.location.href = $(registration_form).val();
	});


	// QUICKVIEW MODAL
  $('#js-quickview-modal').on('show.bs.modal', function(e) {
    var url = $(e.relatedTarget).data('url');
    modalFillContent($(this), url);
  });

  // REVIEW MODAL
  $('#js-review-modal').on('show.bs.modal', function(e) {
    var url = $(e.relatedTarget).data('url');
    modalFillContent($(this), url);
  }).on('click','.btn-submit-review, .js-btn-submit-review', function(e){
      var $this = $(this),
          modal = $(e.delegateTarget),
          form = $this.closest('form'),
          url = form.data('url'),
          data = form.serializeArray();

      // Add bullet data from inputs to form data
      var review_bullets = modal.find('.reviewbullets-container');
      if (review_bullets.length > 0){
        var bullet_array = [],
            count = 1;
        review_bullets.each( function(i){
          var type = $(this).hasClass('bullets-positive') ? 'positive' : 'negative';
          $(this).find('.inputs input').each( function(j, e) {
            var value = $(this).val();
            if (value != '') {
              bullet_array.push({"sequence": count, "text": value, "type": type});
              count++;
            }
          });
        });
        data.push({name: "bullets", value: JSON.stringify(bullet_array)});
      }

      // Post form
      $.post(url, $.param(data), function(res) {
        var inputs = $('.js-review-form').find('input,textarea');
        inputs.parent('.form-group').removeClass('has-error');
        inputs.siblings('.help-block').text('');

        if (res.form_errors !== undefined) {
          $.each(res.form_errors, function(key, val){
            var input = $('[name='+ key +']');
            input.parent('.form-group').addClass('has-error');
            input.siblings('.help-block').text(val[0]);
          });
        } else {
          modal.find('.modal-body-form').hide();
          modal.find('.modal-body-success').show();
        }
		  });
  });

  function modalFillContent(modal, url) {
    modal.find('.modal-content').html('<div class="loader-icon"><div><p></p><p></p><p></p></div></div>');
    $.get(url, {}, function(data) {
      modal.find('.modal-content').html(data);
    });
  }


	// ADDRESS ADD MODAL
	$('#js-add-address-modal').on('show.bs.modal', function() {
		var $this = $(this),
        button = $this.find('button'),
        form = $this.find('form:eq(0)'),
        xhr = $this.find('#xhr-content');

		// load content
		var url = form.attr('action');
		$.get(url, function(data) {
			xhr.html(data.html);
		});

		button.on('click',function(e) {
			e.preventDefault();
			$.post(url, form.serialize(), function(data) {
				if (data.status == 1) {
					location.reload();
					return;
				}
				xhr.html(data.html);
			});
		});
	});

  // ADDRESS EDIT MODAL
  $('a[data-target="#js-edit-address-modal"]').on('click',function(){
    var address_type = $(this).data('addressType'),
        url = $(this).data('url'),
        modal = $('#js-edit-address-modal');
    modal.find('.js-address-type').text(address_type);
    modal.find('form').attr('action',url);
  });
  $('#js-edit-address-modal').on('show.bs.modal', function(e) {
    var $this = $(this),
        button = $this.find('button[type=submit]'),
        form = $this.find('form:eq(0)'),
        xhr = $this.find('#xhr-content');

    // load content
    var url = form.attr('action');
    $.get(url, function(data) {
      xhr.html(data.html);
    });

    button.on('click',function(e) {
      e.preventDefault();
      $.post(url, form.serialize(), function(data) {
        if (data.status == 1) {
          location.reload();
          return;
        }
        xhr.html(data.html);
      });
    });
	});


  // PARTY MODAL
  $('#js-party-modal').on('show.bs.modal', function() {
    var $this = $(this),
        section_search = $this.find('.section-search'),
        section_confirm = $this.find('.section-confirm');

    section_search.show();
    section_confirm.hide();

  }).on('shown.bs.modal', function() {
    var $this = $(this),
        parties = $this.find('.js-parties'),
        basket_count = $this.data('basket'),
        bar = $this.find('.js-progress-bar');
    //remove below if statements after all themes are transisioned to new css/js class split
    if (parties == undefined || parties.length == 0) {
      parties = $this.find('.parties');
    }
    if (bar == undefined || bar.length == 0) {
      bar = $this.find('.progress-bar');
    }

    // progress bar animation
    var start = new Date(),
        limit = 5;
    var interval = window.setInterval(function () {
      var elapsed = new Date() - start;
      bar.width(((elapsed / limit) * 100) + "%");
      if (elapsed >= limit) {
        window.clearInterval(interval);
      }
    }, 1);

    // load content
    var url = $this.find('.modal-body').attr('data-url');
    $.get(url, function(data) {
      parties.html(data);
    });

    // handle form
    var form = $this.find('form'),
        input = $this.find('input'),
        submit = $this.find('button'),
        list = parties,
        form_type = form.data('type');

    input.val('').focus();

    // warning when changing user
    if (getBasketCount(basket_count) > 0){
      var section_search = $this.find('.js-section-search'),
          section_confirm = $this.find('.js-section-confirm');
      //remove below if statements after all themes are transisioned to new css/js class split
      if (section_search == undefined || section_search.length == 0) {
        section_search = $this.find('.section-search');
      }
      if (section_confirm == undefined || section_confirm.length == 0) {
        section_confirm = $this.find('.section-confirm');
      }

      parties.on('click', 'a', function(e){
        var url = $(this).attr('href');

        e.preventDefault();
        section_search.hide();
        section_confirm.show();

        section_confirm.on('click', '.btn-confirm, .js-btn-confirm',function(){
          window.location.href = url;
        });
      });
    }

    form.submit(function(e) {
      e.preventDefault();
      e.stopPropagation();
      submit.click();
    });

    if(form_type=='internal'){
      // internal users can search through all parties (back-end search)
      var url = form.get(0).action;

      submit.on('click',function(e) {
        e.preventDefault();
        if (input.val() == '') {
          return;
        }
        $.ajax({
          url: url,
          dataType: 'json',
          data: {
            query: input.val()
          },
          success: function(data) {
            list.html(data.items)
          }
        });
      });

    } else {
      // non-internal users can only search within displayed list (js search)
      submit.on('click',function(e) {
        e.preventDefault();
        input.quicksearch('.parties .list-group>a');
      });
    }

  });


	// PREMIUM MODAL & OPTIONS MODAL
	$('#js-premium-modal, #js-options-modal').on('shown.bs.modal', function(e) {
		var $this = $(this),
			  url = '';

		url = $this.data('url');
		$this.data('url', '');

		if (! url) {
			url = $(e.relatedTarget).data('url');
		}

		$this.find('.modal-content').empty();

		$.get(url, function(data) {
			$this.find('.modal-content').html(data.html);
		});
	});


  // HOTSPOT WIDGET
  (function($, viewport){
    $(document).ready(function() {
      var hotspotWrapper = $('.js-img-hotspot-wrapper');
      //remove below if statement after all themes are transisioned to new css/js class split
      if (hotspotWrapper == undefined || hotspotWrapper.length == 0) {
        hotspotWrapper = $('.img-hotspot-wrapper');
      }

      if (hotspotWrapper.length) {
        var hotspot = $('.js-hotspot');
        //remove below if statement after all themes are transisioned to new css/js class split
        if (hotspot == undefined || hotspot.length == 0) {
          hotspot = $('.hotspot');
        }
        var openHotspot = function(target){
          var parent = target.closest('.js-hotspot');
          //remove below if statement after all themes are transisioned to new css/js class split
          if (parent == undefined || parent.length == 0) {
            parent = target.closest('.hotspot');
          }

          hotspot.not(parent).removeClass('open');
          parent.toggleClass('open');
        },
        closeHotspot = function(target){
          target.data('timeout',setTimeout(function(){
            hotspot.removeClass('open');
          },500));
        };

        if(viewport.is('<md')) {
          // TOUCH DEVICES
          hotspotWrapper.on('click','.hotspot-target, .js-hotspot-target', function(){
            openHotspot($(this));
          }).on('click','.hotspot-close, .js-hotspot-close', function(){
            hotspot.removeClass('open');
          });
        } else {
          // DESKTOP
          var hotspot_target = hotspotWrapper.find('.js-hotspot-target');
          //remove below if statement after all themes are transisioned to new css/js class split
          if (hotspot_target == undefined || hotspot_target.length == 0) {
            hotspot_target = hotspotWrapper.find('.hotspot-target');
          }

          hotspot_target.hoverIntent(
            function(){ openHotspot($(this)); },
            function(){ closeHotspot($(this)); }
          );
          hotspotWrapper.on('mouseenter','.hotspot-detail, .js-hotspot-detail', function(){
            clearTimeout($(this).siblings('.hotspot-target').data('timeout'));
            clearTimeout($(this).siblings('.js-hotspot-target').data('timeout'));
          }).on('click',function(){
            hotspot.removeClass('open');
          });
        }
      }
    });
  })(jQuery, ResponsiveBootstrapToolkit);


	// CATALOG SELECTOR
	$('.js-catalog-selector').change(function(e) {
		var $this = $(this),
        url = $this.attr('data-url'),
        val = $this.val();
		$.post(url, {catalog_id: val}, function() {
			window.location.reload();
		});
	});

  if (typeof NO_TYPEAHEAD === 'undefined' && typeof Bloodhound !== 'undefined') {
    var autocomplete_all = typeof AUTOCOMPLETE_VERSION !== 'undefined' && AUTOCOMPLETE_VERSION === 3;

    function activate_suggestion(suggestion = 'suggestions') {
      const activate_suggestion = new Bloodhound({
        limit: 6,
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
          url: typeof AUTOCOMPLETE_VERSION !== 'undefined' && AUTOCOMPLETE_VERSION === 3 ?
            `${autocomplete.url}?search_term=%QUERY` :
            `${autocomplete.url}?suggest_type=${suggestion}&search_term=%QUERY`,
          filter: response => {
            if (autocomplete_all && response[suggestion]) {
              return response[suggestion].data
            }

            if (autocomplete_all) {
              return null
            }

            return response;
          }
        }
      });

      activate_suggestion.initialize();

      return {
        type: suggestion,
        bloodhound: activate_suggestion
      }
    }

    var autocomplete = {
      element: document.querySelector('#autocomplete_url')
    };
    autocomplete.url = (
      autocomplete_all ? autocomplete.element.value : autocomplete.element.getAttribute('data-url')
    );

    var suggestion_types = ['product', 'search', 'tree', 'brand', 'blog', 'site_content', 'popular'];
    var suggestions = [];

    for (let suggestion of suggestion_types) {
      suggestions.push(activate_suggestion(suggestion));
    }

    var typeAheadInput = document.querySelectorAll('.typeahead');

    [].forEach.call(typeAheadInput, (typeahead_input) => {
      const suggestions_with_data = [];

      for (let suggestion of suggestions) {
        const source = suggestion.bloodhound.ttAdapter();

        suggestions_with_data.push({
          name: 'search-term',
          displayKey: 'value',
          source,
          templates: {
            header: `<hr><div class="dropdown-header ac_${suggestion.type}">${js_translations[`ac_${suggestion.type}`]}</div>`,
            suggestion: data => data.picture ? Handlebars.compile(`<div class="media">
              <div class="media-left">
                <img src="${data.picture}" width="120" alt="${data.value}">
              </div>
              <div class="media-body"><p>${data.value}</p></div>
            </div>`) : Handlebars.compile(`<p>${data.value}</p>`)
          }
        });
      }

      $(typeahead_input).typeahead(
        {
          highlight: true,
          minLength: 3
        },
        ...suggestions_with_data
      ).bind('typeahead:selected', function(event, suggestion) {
        window.location.href = suggestion.url;
      });
    });
  }

  // FORM VALIDATION
  if (typeof(FORM_VALIDATION) != 'undefined') {
    console && console.log('::FRONTEND_FORM_VALIDATION_ACTIVE::');
    var submit_allow = false;
    $('[data-validators]').each(function () {
      var $form = $(this),
          validators = $form.data('validators');

      $('.form-control-feedback').remove();

      if (validators != '') {
        $.each(validators, function (key, validator) {
          $form.find('[type="text"][name="' + key + '"], select[name="' + key + '"]').on('change', function () {
            $(this).form_validation(validator);
          })
          .on('input', function () {
            $(this).attr('data-triggered', true);
          })
          .on ('blur', function () {
            var triggered = $(this).data('triggered');
            if (triggered) {
              $(this).form_validation(validator);
            }
          })
          .on('focus', function () {
            if ($(this).hasClass('has-error')) {
              $(this).clear_validation_errors();
            }
          });
          $form.find('[type="radio"][name="' + key + '"]').on('click, change', function () {
            $(this).form_validation(validator);
          });
        });

        $form.find('[type="submit"]').on('click', function (e) {
          if (!submit_allow) {
            e.preventDefault();
            e.stopPropagation();
            $.each(validators, function (key, validator) {
              $form.find('[type="text"][name="' + key + '"], select[name="' + key + '"]').attr('data-triggered', true).trigger('blur');
              $form.find('[type="radio"][name="' + key + '"]').trigger('change');
            });

            var active_errors = $form.find('.js-form-validation-error');
            if (active_errors.length == 0) {
              submit_allow = true
              $(this).trigger('click');
            }
          }
        });
      }
    });
  }

  $('a.toggle-consumer-mode').on('click', function(e) {
    var url = $(e.target).data('url');
    $.post(url, {}, function(data) {
      window.location.reload();
    });
  });

});

function checkIfProductInWishList(response, product_id) {
  const wishlist = response.state;
  if (!wishlist){
    return false
  }
  for (let i  = 0; i < wishlist.length; i++) {
    let item = wishlist[i];
    if (parseInt(product_id) === item['product_id']) {
      return item['is_enabled']
    }
  }
  return false
}

$('.product-wishlist').click(function(event) {
  let $this = $(this);
  const url = $this.attr('data-url');
  const product_id =  $this.attr('data-id');
  const is_enabled = $this.children('i').hasClass('far fa-heart');
  $.ajax({
    url: url,
    data: JSON.stringify({'state': [{'product_id': product_id, 'is_enabled': is_enabled}]}),
    contentType: "application/json",
    method: 'POST',
    success: function(response) {
      let isProductInWishList = checkIfProductInWishList(response, product_id);
      let faClassWishList = isProductInWishList ? 'fas fa-heart' : 'far fa-heart';
      let removeClassWishList = isProductInWishList ? 'far fa-heart' : 'fas fa-heart';
      $this.children('i').removeClass(removeClassWishList);
      $this.children('i').addClass(faClassWishList);
    }
  })
});

var switchTheme = document.querySelector('aside.cms-tools [data-cs-switch-theme]');
if (switchTheme) {
  switchTheme.addEventListener('click', function () {
    if (Cookies.get('cs_theme') !== undefined) {
      Cookies.remove('cs_theme');
    } else {
      Cookies.set('cs_theme', 'cloudsuite_responsive', {
        path: '/'
      });
    }

    window.location.reload();
  });
}

var getAllCacheLinks = document.querySelectorAll('aside.cms-tools [data-cs-debug-ajax-load]');

[].forEach.call(getAllCacheLinks, function(cacheLink) {
  cacheLink.addEventListener('click', function (event) {
    event.preventDefault();
    const linkHref = event.currentTarget.getAttribute('href');
    const httpRequest = new XMLHttpRequest();
    httpRequest.open('GET', linkHref, true);

    httpRequest.onprogress = function () {
      $('#js-loader-modal').modal({
        backdrop: 'static',
        keyboard: false
      });
    };

    httpRequest.onload = function () {
      return window.location.reload();
    };

    httpRequest.send(null);
  });
});

(function setGlobalDatepickerDefaults() {
  if (typeof LOCALE !== 'undefined' && typeof DATEFORMAT !== 'undefined'){
    $.datepicker.regional['nl'] = {
      monthNames: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
      dayNames: ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
      dayNamesMin: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
    };

    $.datepicker.regional['en'] = {
      monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    };

    $.datepicker.setDefaults($.extend({
        changeMonth: true,
        changeYear: true,
        dateFormat: DATEFORMAT,
        firstDay: 1,
        isRTL: false,
        maxDate: "+1y",
        showMonthAfterYear: false,
        showOtherMonths: true,
        selectOtherMonths: true,
        yearSuffix: '',
      },
      $.datepicker.regional[LOCALE]
    ));
  }
})();

(function formatDate() {
  const long = { year: 'numeric', month: 'long', day: 'numeric' };
  const short = { year: 'numeric', month: 'numeric', day: 'numeric' };

  function setInnerText(element, options) {
    const dateStr = element.dataset.date
    const dateObj = new Date(dateStr);
    if (!isNaN(dateObj) && LOCALE) {
      element.innerText = dateObj.toLocaleString(LOCALE, options);
    } else {
      element.innerText = dateStr !== 'None' ? dateStr : '-';
    }
  }

  document.querySelectorAll('.js-format-date-long').forEach(element => setInnerText(element, long));
  document.querySelectorAll('.js-format-date-short').forEach(element => setInnerText(element, short));
})();

const backorderSales = document.querySelectorAll('.backorders .sale');
[].forEach.call(backorderSales, (backorderSale) => {
  backorderSale.addEventListener('click',  () => window.location.href = backorderSale.dataset.url)
});

import * as exposed_functions from './exposed_functions';
import { getGoogleSessionID } from './payment/functions';
import { FilterSearch } from './filterSearch';
import { ReviewsPagination } from './reviews';
import DropShipmentModal from './modal/drop_shipment';
import SelectDeliveryAddress from './delivery_points';
import { promoteLargerPackaging } from './promote-larger-packaging';
import { dealerServicePoint } from './dealer-service-point';
import { throttle } from './helper/throttle';

import { loadExtraAddresses } from './account/index'

for (const key in exposed_functions) {
  if(Object.prototype.hasOwnProperty.call(exposed_functions, key)) {
    window[key] = exposed_functions[key];
  }
}
window['getGoogleSessionID'] = getGoogleSessionID;

window.lazyLoadImages();

const filterSearch = new FilterSearch();

filterSearch.init();
DropShipmentModal();
SelectDeliveryAddress();
promoteLargerPackaging.init();
dealerServicePoint.init();
loadExtraAddresses();

const reviewsButton = document.querySelector('#show_more_reviews');
const reviewsContainer = document.querySelector('#review-container');
const reviewsLoader = document.querySelector('#reviews-loader');
const reviewsPagination = new ReviewsPagination(reviewsButton, reviewsContainer, reviewsLoader);
reviewsPagination.clickHandler();
